import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

const styles = theme => ({})

const PerPage = 50;
export class Pager extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { total, page } = this.props;
        page = parseInt(page);
        let pageCount = Math.ceil(total/PerPage);
        let startPage = 1;
        if (pageCount > 10) {
            if(page + 10 > pageCount) {
                startPage = pageCount - 10;
            } else {
                startPage = page;
            }
        }
        let pages = [];
        let pagesFinish = pageCount < 10 ? pageCount : 10;
        for (let i = 0; i < pagesFinish ; i++) {
           pages.push(<Button key={`but-${i}`} style={{fontWeight: (startPage + i) == page ? 'bold' : 200}}
                              onClick={e => this.props.handle(this.props.token, (startPage + i), this.props.search)}>{startPage + i}</Button>);
        }
        // console.log('Pager!')
         // if page > 1  print prev
        return (
            <Typography component="div">
                <Button onClick={e => this.props.handle(this.props.token, (page - 1), this.props.search)} disabled={page > 1? false: true}>&lt;</Button>
                {(pageCount>10) && (page>10) && (<Button disabled>...</Button>)}
                {pages}
                {(pageCount>10) && (page + 10 < pageCount) && (<Button disabled>...</Button>)}
                <Button onClick={e => this.props.handle(this.props.token, (page + 1), this.props.search)} disabled={ pageCount - page > 1 ? false : true}>&gt;</Button>
            </Typography>
        )

    }
}

Pager.propTypes = {
    total: PropTypes.number,
    page: PropTypes.number,
    handle: PropTypes.func.isRequired,
    search: PropTypes.string,
    token: PropTypes.string
}

Pager.defaultProps = {
    total: 50,
    page: 1,
    handle: function (token, page, search, inspection_id) {
        console.log(page);
    }
}

export default withStyles(styles)(Pager);








// WEBPACK FOOTER //
// ./assets/src/js/components/controls/Pager.jsx